import cn from 'classnames';

import styles from './InlineBoldText.module.scss';

interface InlineBoldTextProps {
    text: string;
    className?: string;
}

export default function InlineBoldText(props: InlineBoldTextProps) {
    const { text, className } = props;

    const parts = text.split(/(\*\*[^*]+\*\*)/);

    return (
        <span className={cn(styles.inlineBoldText, className)}>
            {parts.map((part, index) =>
                part.startsWith('**') && part.endsWith('**') ? (
                    <strong key={`bold-${index}-${part}`}>{part.slice(2, -2)}</strong>
                ) : (
                    <span key={`text-${index}-${part}`}>{part}</span>
                )
            )}
        </span>
    );
}
